import { render, staticRenderFns } from "./ResumenPedido.vue?vue&type=template&id=439a4c98"
import script from "./ResumenPedido.vue?vue&type=script&lang=js"
export * from "./ResumenPedido.vue?vue&type=script&lang=js"
import style0 from "./ResumenPedido.vue?vue&type=style&index=0&id=439a4c98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports